var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-partner"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "text-2xl font-bold mb-6"
  }, [_vm._v("Creat New Order")]), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('div', {}, [_c('LinkButton', {
    attrs: {
      "buttonText": "Cancel",
      "type": "secondary",
      "linkType": "internal",
      "url": "/"
    }
  })], 1), _c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Save",
      "type": "primary"
    }
  })], 1)])]), _c('div', {
    staticClass: "border shadow-lg rounded-md bg-white p-6 flex gap-20"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama"
    },
    model: {
      value: _vm.payload.name,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "name", $$v);
      },
      expression: "payload.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Email"
    },
    model: {
      value: _vm.payload.email,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "email", $$v);
      },
      expression: "payload.email"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "type": "Lokasi",
      "label": "Lokasi"
    },
    model: {
      value: _vm.payload.location,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "location", $$v);
      },
      expression: "payload.location"
    }
  })], 1), _vm._m(0)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-4 relative"
  }, [_c('p', {
    staticClass: "text-base text-neutral-500 font-medium mb-1 block"
  }, [_vm._v("Logo")]), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "nama": "file",
      "id": "name"
    }
  }), _c('label', {
    staticClass: "border border-dashed p-6 rounded-md inline-block border-neutral-700 text-neutral-700 w-60 text-center cursor-pointer",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Upload Image")])]);

}]

export { render, staticRenderFns }